// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { CommaFormat } from '../../../../../elements/Price/Price';

import Rating from '../../../../../elements/Rating/Rating';
import type {BagItem, ShoppingCartItem} from '../../../../../entities';
import RadioButton from '../CustomRadioButton/RadioButton';

import defaultPic from '../../../../../assets/img/profileplaceholder.jpg';
import style from './DIYCourier.scss';

import type { ForecastCourier } from '../../api';

type Props = {
  +items: (ShoppingCartItem | BagItem)[];
  +forecastCouriers: ForecastCourier[];
  +handleChangeOption: (option: number) => void;
  +isLoading?: boolean;
  +selectedIndex?: number;
};

type State = {};

export default class DIYCourier extends Component<Props, State> {
  // This total is amount
  buildOption(courier: ForecastCourier, index: number, selectedIndex?: number, shouldInclude: boolean = true) {
    const { handleChangeOption, forecastCouriers } = this.props;
    const active = index === selectedIndex;
    const rating = parseFloat(courier.courier.rating.value);
    const totalRating = parseInt(courier.courier.rating.maxValue, 10);
    const filledRatingWidthPercent = (rating / totalRating) * 100;
    const filledRatingExtraMargin = 3 /*+ Math.floor((filledRatingWidthPercent * totalRating) / 100)*/;
    const filledRatingWidthStr = `calc(${(filledRatingWidthPercent).toFixed(2)}% - ${filledRatingExtraMargin}px)`;
    let subtitle = (
      <FormattedMessage id="newOrder.quote.diy.shipping.days">{
        txt => <p
          className={style.shippingDays}>{courier.days} {txt}</p>
      }</FormattedMessage>);
    let courierName = (
      <FormattedMessage id="newOrder.quote.diy.courier.nameSuffix">{
        txt => <p className={style.courierName}>{courier.courier.name} {txt}</p>
      }</FormattedMessage>
    );
    if (courier.courier.id !== "CR09043495") {
      /*subtitle = (
        <FormattedMessage id="newOrder.quote.diy.specialShipping">{
          txt => <p className={style.shippingDays}>{txt}</p>
        }</FormattedMessage>);*/
      courierName = (
        <FormattedMessage id="newOrder.quote.diy.traveler.nameSuffix">{
          txt => <p className={style.courierName}>{courier.courier.name} {txt}</p>
        }</FormattedMessage>
      );
    }
    return (
      <div key={index}
           className={classNames(style.option, { [style.active]: active, [style.hidden]: !shouldInclude })}
           onClick={_ => handleChangeOption(index)}>
        <RadioButton checked={selectedIndex === index}
                     name="courier"/>
        <div className={style.content}>
          <div className={style.courierInfoWrap}>
            <img src={courier.courier.image || defaultPic}
                 alt="courier"/>
            <div className={style.textWrap}>
              {courierName}
              <p
                className={style.location}>{courier.courier.address.admin2 ? `${courier.courier.address.admin2.name}, ` : ''} {courier.courier.address.admin1.name}</p>
              <Rating rating={rating}
                      totalRating={totalRating}/>
            </div>
          </div>
          <FormattedMessage id="newOrder.quote.diy.importation">{
            txt => <p className={classNames(style.shipping, { [style.active]: active })}>{txt}: $ <CommaFormat
              price={parseFloat(courier.importationFee) +
              parseFloat(courier.customsDuties) +
              parseFloat(courier.qempo) +
              parseFloat(courier.lastMileShipping)}/></p>
          }</FormattedMessage>
          {subtitle}
        </div>
      </div>
    );
  }
  
  static shouldIncludeCourier(forecastCourier: ForecastCourier, items: (ShoppingCartItem | BagItem)[]) {
    // Delete ChaskiBox :'(
    if (forecastCourier.courier.id === 'CR14502361') return null;
    
    for (let item of items) {
      const itemsWeightCriteria = [5, 2, 8, 14, 13, 17, 7, 9, 15, 10].includes(item.itemCategoryId);
      // more then 8lbs
      if (itemsWeightCriteria && parseFloat(item.weight) > 3.62874) {
        if (forecastCourier.courier.id !== 'CR09043495') return null;
      }
      
      // Do not show Envios Condor
      if (forecastCourier.courier.id === 'CR02746321') {
        return null;
      }
      
      // Show VikCourier only in (Laptops, Phones, Tablets, Smartwatches)
      /*const itemsVikIncluded = [1, 3, 11, 19].includes(item.itemCategoryId);
      if (itemsVikIncluded) {
        if (forecastCourier.courier.id === 'CR08065879') {
          return forecastCourier;
        } else return null;
      }else {
        if (forecastCourier.courier.id === 'CR08065879') {
          return null;
        }
      }*/
    }
    return forecastCourier;
  }

  render() {
    const { forecastCouriers, isLoading, selectedIndex, items } = this.props;
    /*    const date = typeof selectedIndex !== 'undefined' &&
          moment().add(forecast[selectedIndex].tier.days, 'days').format('MMM DD, YYYY');*/

    const courierOptions = forecastCouriers
      .sort((a, b) => a.courier.name.toLowerCase() > b.courier.name.toLowerCase() ? -1 : 1)
      .map((courier: ForecastCourier, index: number) =>
        this.buildOption(courier, index, selectedIndex, !!DIYCourier.shouldIncludeCourier(courier, items))
      );

    return (
      <div className={classNames(style.optionsWrap, { [style.loading]: isLoading })}>
        {courierOptions}
      </div>);
  }
}

DIYCourier.propTypes = {
  items: PropTypes.array.isRequired,
  forecastCouriers: PropTypes.array.isRequired,
  handleChangeOption: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/DIYCourier/DIYCourier.jsx